export function inclusionTravelPeriodFilter(
  inclusions: App.PackageInclusion[],
  checkIn?: moment.Moment,
  checkOut?: moment.Moment,
): string {
  const rateInclusions = inclusions.filter(inclusion => {
    if (inclusion.type !== 'Rate') {
      return false
    }

    if (!(checkIn && checkOut) && inclusion.travelPeriodFrom && inclusion.travelPeriodTo) {
      return false
    } else if (checkIn && checkOut && inclusion.travelPeriodFrom && inclusion.travelPeriodTo) {
      return checkIn.isBetween(inclusion.travelPeriodFrom, inclusion.travelPeriodTo, 'days', '[]') &&
        checkOut.isBetween(inclusion.travelPeriodFrom, inclusion.travelPeriodTo, 'days', '[]')
    }

    return true
  })

  const otherInclusions = inclusions.filter(inclusion => {
    return inclusion.type !== 'Rate'
  })

  if (rateInclusions.length > 0) {
    return rateInclusions.map(inclusion => inclusion.description).join('\n')
  }

  return otherInclusions.map(inclusion => inclusion.description).join('\n')
}
